import ricardo from '../img/ricardo.png'
import hector from '../img/hector.png'
import alan from '../img/alan.png'
import mauricio from '../img/mauricio.png'
import guadalupe from '../img/guadalupe.png'
import alfonso from '../img/alfonso.png'

export const players = [
  {
    name: 'Ricardo Silva de Luna',
    place: 'México',
    category: 'Ceguera total · B1',
    rank: 'Campeón mundial',
    photo: ricardo,
    photoAlt: 'Ricardo Silva de Luna y su guía en el campo',
    summary:
      'Compite junto a su guía Ismael Álvarez Delgado. Es uno de los máximos exponentes de la categoría B1 a nivel internacional.',
    highlights: [
      'Campeón mundial B1 Men’s Low Net en el ISPS Handa Canadian Open / IBGA World Championship (Simcoe, Ontario).',
      'Campeón B1 varonil del Spanish Blind Golf Open 2026 en Isla Canela, con tarjeta de 229 golpes.',
      'Subcampeón Gross B1 en ediciones previas del circuito canadiense (Columbia Británica).',
    ],
  },
  {
    name: 'Héctor Antonio Ramírez Taxilaga',
    place: 'Minatitlán, Veracruz',
    category: 'WR4GD · Neto',
    rank: 'Mejor mexicano en Neto',
    photo: hector,
    summary:
      'El golfista mexicano mejor calificado en la división Neto del World Ranking for Golfers with Disability.',
    highlights: [
      'Representa a Veracruz en el escalafón mundial.',
      'Compite en la división que mide el rendimiento ajustado por hándicap.',
    ],
  },
  {
    name: 'Alan Enrique Salas Rueda',
    place: 'Ciudad de México',
    category: 'Stableford · neurológica',
    rank: 'Lugar 25 · 15,833 pts',
    photo: alan,
    photoClass: 'object-[72%_center]',
    summary:
      'Registrado en EDGA desde el 8 de febrero de 2023. Juega con hándicap 24.3 y ocupa el puesto 25 de Stableford.',
    highlights: [
      'Discapacidad neurológica. 39 años.',
      'Su última competencia registrada es del 10 de marzo de 2026.',
    ],
  },
  {
    name: 'Mauricio Gutiérrez',
    place: 'México',
    category: 'Juego sentado',
    rank: 'Perfil EDGA',
    photo: mauricio,
    summary:
      'Empezó a los cuatro años, en una familia de golfistas. Hoy destaca por adaptar el swing desde la posición sentada.',
    href: 'https://www.edgagolf.com/profiles/35-mauriciogutierez',
    highlights: [
      'Su perfil está publicado por la European Disabled Golf Association.',
    ],
  },
  {
    name: 'Alfonso Balderas',
    place: 'Querétaro',
    category: 'Golf para sordos',
    rank: 'Deaflympics 2025',
    photo: alfonso,
    photoClass: 'object-[68%_center]',
    summary:
      'Debutó en Tokio en 2025, junto a Guadalupe Govea. Era la primera vez de los dos en unos Juegos para sordos.',
  },
  {
    name: 'Guadalupe Govea',
    place: 'Guadalajara',
    category: 'Golf para sordos',
    rank: 'Deaflympics 2025',
    photo: guadalupe,
    summary:
      'En Tokio, en 2025, integró la delegación mexicana junto a Alfonso Balderas, de Querétaro.',
  },
]

export const timeline = [
  {
    year: '1920',
    scope: 'mundo',
    title: 'Tommy McAuliffe demuestra el swing adaptado',
    place: 'Estados Unidos',
    text: 'En las décadas de 1920 y 1930, McAuliffe —quien perdió ambos brazos en un accidente ferroviario durante su infancia— recorrió exhibiciones sujetando el palo entre el cuello y el hombro.',
  },
  {
    year: '1946',
    scope: 'mundo',
    title: 'Campeonatos de veteranos',
    place: 'Estados Unidos',
    text: 'Tras la Segunda Guerra Mundial, el golf entra a la rehabilitación militar. Desde 1946 se celebran campeonatos nacionales informales entre veteranos, impulsados por pioneros como Clint Russell.',
  },
  {
    year: '1953',
    scope: 'mundo',
    title: 'Nace la USBGA y el golf para ciegos se reglamenta',
    place: 'Filadelfia, Estados Unidos',
    text: 'El abogado y golfista ciego Bob Allman funda la United States Blind Golf Association y asume la presidencia. El torneo nacional formaliza el binomio jugador–guía y las primeras adaptaciones sobre las reglas de la USGA. Charley Boswell, veterano que perdió la vista en combate, gana 16 títulos nacionales y abre clubes de primer nivel al golf adaptado. De ahí sale después la International Blind Golf Association.',
  },
  {
    year: '1954',
    scope: 'mundo',
    title: 'Fundación de la NAGA',
    place: 'Estados Unidos',
    text: 'Dale Bourisseau, veterano con amputación bajo la rodilla, reúne a doce golfistas amputados y crea la National Amputee Golf Association, con apoyo de la PGA y la USGA. En 1989, NAGA institucionaliza First Swing para capacitar a fisioterapeutas y terapeutas ocupacionales.',
  },
  {
    year: '1977',
    scope: 'mundo',
    title: 'Dennis Walters y los vehículos adaptados',
    place: 'Estados Unidos',
    text: 'En 1974 Walters sufre una lesión medular en un coche de golf. Desde 1977 recorre miles de exhibiciones en vehículos adaptados. En 2022, a los 72 años, compite en el primer U.S. Adaptive Open.',
  },
  {
    year: '1995',
    scope: 'mundo',
    title: 'Adaptive Golf Foundation y las primeras sillas de césped',
    place: 'Estados Unidos',
    text: 'Oliver “Sonny” Ackerman, exmarine con amputación de extremidad inferior, funda la Adaptive Golf Foundation junto al profesional de la PGA David Windsor. Tom Houston, paralizado en 1980, impulsa las primeras sillas de ruedas para el césped: la base de los monoplazas actuales.',
  },
  {
    year: '2000',
    scope: 'mundo',
    title: 'Nace la EDGA',
    place: 'Europa',
    text: 'Se funda la European Disabled Golf Association, hoy organismo global de elegibilidad funcional. En 2018 se afilia a The R&A.',
  },
  {
    year: '2002',
    scope: 'mundo',
    title: 'Un solo reglamento para el mundo',
    place: 'USGA y The R&A',
    text: 'USGA y The R&A publican “A Modification of the Rules of Golf for Golfers with Disabilities”, precursor de la Regla 25. Tras el fallo de la Suprema Corte en PGA Tour v. Martin (2001), los ajustes razonables —como el carrito— dejan de verse como ventaja ilegítima. España, Reino Unido, Francia y Suecia empiezan a homologar escuelas y circuitos.',
  },
  {
    year: '2012',
    scope: 'mexico',
    title: 'El golf adaptado llega a México',
    place: 'México',
    text: 'Alejandro Florero, junto a su hermano diagnosticado con Parkinson, inicia el movimiento. Hoy preside la Asociación Nacional de Golf Adaptado.',
  },
  {
    year: '2014',
    scope: 'mundo',
    title: 'The Adaptive Golf Experience',
    place: 'Estados Unidos',
    text: 'El fisioterapeuta Steve Giammona y el profesional de la PGA Andy Hinson consolidan un modelo clínico y deportivo. Crece la cooperación entre la U.S. Adaptive Golf Alliance y la National Alliance for Accessible Golf.',
  },
  {
    year: '2018',
    scope: 'mundo',
    title: 'Primer U.S. Disabled Open y el ranking compartido',
    place: 'Orlando, Florida',
    text: 'La USDGA de Jason Faircloth reúne a 48 golfistas de 8 países en Eagle Creek. Ryan Brendan es el primer campeón, en playoff. Es el primer evento en suelo estadounidense con puntos WR4GD. USGA, The R&A y EDGA asumen juntos el ranking. La USAGA ordena 14 clases funcionales alineadas al IPC. Ese año nace también la Cairns Cup, el formato tipo Ryder Cup entre Estados Unidos y Europa, en memoria de Billy Cairns.',
  },
  {
    year: '2022',
    scope: 'mundo',
    title: 'Arranca el G4D Tour',
    place: 'Europa',
    text: 'El DP World Tour y EDGA lanzan el Golf for the Disabled Tour: siete torneos en las mismas sedes y semanas que el circuito europeo, en campos como The Belfry, Wentworth, Valderrama y Jumeirah Golf Estates. Hay viaje, alojamiento y cobertura televisiva para quienes clasifican por el WR4GD. Ese circuito visibiliza a jugadores como Kipp Popert, Brendan Lawlor, Mike Browne y Rasmus Lia, y abre formación de entrenadores y médicos clasificadores.',
  },
  {
    year: '2023',
    scope: 'mundo',
    title: 'La Regla 25 entra al libro oficial',
    place: 'The R&A y USGA',
    text: 'Desde enero de 2023 las adaptaciones dejan de ser modificaciones locales y forman parte de las Reglas de Golf, en stroke play y match play. Ese año se juega el primer G4D Open en Woburn, Inglaterra: el equivalente a un major abierto del golf adaptado.',
  },
  {
    year: '2024',
    scope: 'mexico',
    title: 'Primer Torneo Nacional de México',
    place: 'Club de Golf México',
    text: 'Trece jugadores nacionales compiten en distintas categorías. Es el primer campeonato de este tipo en el país.',
  },
  {
    year: '2025',
    scope: 'mexico',
    title: 'México debuta en los Deaflympics',
    place: 'Tokio',
    text: 'Alfonso Balderas (Querétaro) y Guadalupe Govea (Guadalajara) son la primera participación mexicana en el golf de los Juegos Olímpicos para sordos.',
  },
  {
    year: '2026',
    scope: 'mexico',
    title: 'I Campeonato Nacional FMG Adaptive Open',
    place: 'Club de Golf México, CDMX',
    text: 'Modalidad Stableford a 18 hoyos diarios. Participan 25 jugadores con discapacidad motriz, intelectual y sensorial: México, más dos de Guatemala, uno de Argentina y uno de Colombia.',
  },
]

export const organizations = [
  {
    name: 'USGA',
    fullName: 'United States Golf Association',
    region: 'Estados Unidos',
    text: 'Junto con The R&A publica las Reglas de Golf, incluida la Regla 25, y homologa eventos para el ranking mundial.',
    href: 'https://www.usga.org',
  },
  {
    name: 'The R&A',
    fullName: 'The Royal and Ancient Golf Club',
    region: 'Mundial',
    text: 'Órgano rector del golf fuera de Estados Unidos y México. Administra el WR4GD junto con la USGA y la EDGA.',
    href: 'https://www.randa.org',
  },
  {
    name: 'EDGA',
    fullName: 'European Disabled Golf Association',
    region: 'Europa · Global',
    text: 'Fundada en 2000 y afiliada a The R&A en 2018. Audita la elegibilidad funcional y organiza el G4D Tour con el DP World Tour.',
    href: 'https://www.edgagolf.com',
  },
  {
    name: 'WR4GD',
    fullName: 'World Ranking for Golfers with Disability',
    region: 'Mundial',
    text: 'Escalafón de 104 semanas en tres divisiones: Gross, Neto y Stableford.',
    href: 'https://www.edgagolf.com',
  },
  {
    name: 'IBGA',
    fullName: 'International Blind Golf Association',
    region: 'Mundial',
    text: 'Hereda el camino abierto en 1953 por la USBGA y el binomio jugador–guía.',
    href: 'https://www.internationalblindgolf.org',
  },
  {
    name: 'ANGA',
    fullName: 'Asociación Nacional de Golf Adaptado',
    region: 'México',
    text: 'Desde 2012 promueve clases, comunidad y competencia para personas con discapacidad en ocho estados.',
    href: '/about',
  },
]

export const rule25 = [
  {
    id: 'visual',
    code: '25.2',
    title: 'Discapacidad visual',
    permit: 'Guía con estatus de caddie',
    summary:
      'Quien compite con ceguera o baja visión (clasificación B1 a B4) puede contar con un ayudante para la alineación, la lectura de distancias y el consejo táctico.',
    points: [
      'El guía tiene el mismo estatus que un caddie.',
      'En el bunker no hay penalidad si el palo toca la arena en la preparación o en el backswing.',
      'Un tercero puede ayudar a dropear y colocar la bola.',
    ],
  },
  {
    id: 'limb',
    code: '25.3',
    title: 'Extremidades',
    permit: 'Prótesis y anclaje del palo',
    summary:
      'Se autorizan prótesis fijas o móviles, incluidas las que se acoplan al grip o al antebrazo.',
    points: [
      'Si la biomecánica lo exige, el palo puede anclarse al torso sin la penalidad del reglamento estándar.',
      'Se permite asistencia física para posicionar, dropear o reponer la bola.',
    ],
  },
  {
    id: 'mobility',
    code: '25.4',
    title: 'Dispositivos de movilidad',
    permit: 'Acceso a green y bunker',
    summary:
      'Cubre muletas, bastones, sillas de ruedas y carritos monoplaza como el SoloRider o el Paragolfer.',
    points: [
      'El dropeo se adapta a la altura de la rodilla o a la posición sentada.',
      'El comité debe permitir el acceso de estos vehículos a greens y bunkers.',
      'Se puede recibir ayuda para colocar el vehículo o mantenerse erguido en el impacto.',
    ],
  },
  {
    id: 'intellectual',
    code: '25.5',
    title: 'Discapacidad intelectual',
    permit: 'Ayudante además del caddie',
    summary:
      'Quien tiene un diagnóstico validado por Virtus puede jugar con un asistente de campo adicional al caddie.',
    points: [
      'El asistente interpreta reglas y estrategia.',
      'Puede marcar o levantar la bola en el green sin autorización previa.',
    ],
  },
]

export const passes = [
  {
    name: 'WR4GD Pass',
    eligible: 'Alcanza el umbral mínimo en alguna de las 10 categorías del IPC.',
    events: 'Circuito EDGA, Premier Series, G4D Tour y U.S. Adaptive Open.',
    ranking: 'Sí suma puntos en Gross, Neto y Stableford.',
  },
  {
    name: 'ACCESS Pass',
    eligible: 'Hay una discapacidad dentro de las 10 categorías, por debajo del umbral WR4GD.',
    events: 'EDGA Access Series y torneos internacionales de iniciación.',
    ranking: 'Compite de forma organizada, sin puntos de ranking.',
  },
  {
    name: 'Access Conditional',
    eligible: 'Discapacidad reconocida por la ley del país, fuera de las categorías del IPC.',
    events: 'Competencias locales y campeonatos nacionales del país emisor.',
    ranking: 'Solo vale en el territorio que lo expide.',
  },
]

export const divisions = [
  {
    name: 'Stroke Play Scratch',
    detail: 'Gross',
    text: 'Amateurs o profesionales con Hándicap Index de 18.4 o menos.',
  },
  {
    name: 'Stroke Play Neto',
    detail: 'Hasta 18.4',
    text: 'Mide el rendimiento ya ajustado por hándicap.',
  },
  {
    name: 'Net Stableford',
    detail: '18.5 a 54.0',
    text: 'Abre la competencia a quienes juegan con afecciones más severas.',
  },
]

export const equipment = [
  {
    name: 'Paragolfer',
    maker: 'Ottobock',
    text: 'Vehículo todoterreno con elevación hidráulica. Pasa de la posición sentada a una bipedestación segura para ejecutar el swing. La verticalización también cuida hueso, circulación y digestión en personas con lesión medular.',
  },
  {
    name: 'SoloRider',
    maker: 'Monoplaza',
    text: 'Chasis ligero y neumáticos de muy baja presión. Reparte el peso por debajo de una pisada humana, así puede cruzar el green sin marcarlo. El asiento gira e inclina.',
  },
  {
    name: 'Prótesis de swing',
    maker: 'Fibra de carbono',
    text: 'Terminales y articulaciones biaxiales que absorben el torque del impacto y mantienen la tracción en el grip sin lastimar el muñón.',
  },
  {
    name: 'Grips y guantes',
    maker: 'Tracción',
    text: 'Cinchas y empuñaduras de mayor diámetro para compensar pérdida de fuerza de prensión o parálisis parcial en los brazos.',
  },
]

export const regions = [
  {
    name: 'Xochimilco',
    state: 'Ciudad de México',
    type: 'Sede',
    text: 'Clases gratuitas los martes y jueves, de 9:30 a 13:00, con Alejandro Florero. Principiantes y avanzados, todas las edades.',
  },
  { name: 'Veracruz', type: 'Red', text: 'De aquí sale Héctor Antonio Ramírez Taxilaga, el mexicano mejor ubicado en la división Neto del WR4GD.' },
  { name: 'Quintana Roo', type: 'Red', text: 'Acompañamiento a jugadores foráneos y coordinación para torneos.' },
  { name: 'Querétaro', type: 'Red', text: 'Casa de Alfonso Balderas, quien debutó con México en los Deaflympics de Tokio 2025.' },
  { name: 'Aguascalientes', type: 'Red', text: 'Seguimiento a jugadores de la red nacional.' },
  { name: 'Michoacán', type: 'Red', text: 'Apoyo para que la práctica no se quede solo en la capital.' },
  { name: 'Puebla', type: 'Red', text: 'Enlace con jugadores que entrenan fuera de Xochimilco.' },
  { name: 'Morelos', type: 'Red', text: 'Parte de los ocho estados donde la asociación da seguimiento.' },
]

export const posts = [
  {
    slug: 'origenes-del-golf-adaptado',
    title: 'De la rehabilitación de posguerra a un deporte con reglas',
    excerpt: 'El golf adaptado no nació en un club. Nació en hospitales militares, con veteranos, y tardó décadas en tener un reglamento propio.',
    category: 'Historia',
    date: '2026-03-01',
    readTime: '6 min',
    sections: [
      {
        heading: 'Una herramienta terapéutica',
        paragraphs: [
          'Después de la Segunda Guerra Mundial, los cuerpos médicos militares usaron el golf para recuperar equilibrio, fuerza, resistencia y confianza en personas heridas. El campo abierto importaba tanto como el swing.',
          'Desde 1946 ya había campeonatos informales entre veteranos. El paso a una disciplina reglamentada llegó en 1953.',
        ],
      },
      {
        heading: '1953 y 1954: dos asociaciones',
        paragraphs: [
          'En 1953, Bob Allman funda en Filadelfia la United States Blind Golf Association. El torneo nacional fija el binomio jugador–guía: alineación, distancias y lectura del terreno. Charley Boswell, veterano que perdió la vista en combate, gana 16 títulos y vuelve visible el circuito.',
          'En 1954, Dale Bourisseau reúne a doce golfistas amputados y crea la National Amputee Golf Association, con respaldo de la PGA y la USGA. En 1989 esa asociación lanza First Swing, para enseñar a terapeutas a usar el golf dentro del hospital.',
        ],
      },
      {
        heading: 'Pioneros del swing',
        paragraphs: [
          'Tommy McAuliffe, sin ambos brazos, exhibió en los años veinte y treinta un swing sujetando el palo entre el cuello y el hombro. Dennis Walters, con lesión medular desde 1974, recorrió miles de exhibiciones en vehículos adaptados y en 2022, a los 72 años, jugó el primer U.S. Adaptive Open.',
          'En 1995, Sonny Ackerman funda la Adaptive Golf Foundation. Tom Houston impulsa las sillas de ruedas para césped que anteceden al SoloRider y al Paragolfer.',
        ],
      },
    ],
  },
  {
    slug: 'la-regla-25',
    title: 'Qué cambia la Regla 25, en palabras claras',
    excerpt: 'Desde 2023 las adaptaciones ya no son un anexo local. Son parte de las Reglas de Golf y equilibran la competencia sin regalar golpes.',
    category: 'Reglamento',
    date: '2026-03-08',
    readTime: '7 min',
    sections: [
      {
        heading: 'Del manual de 2002 al libro oficial',
        paragraphs: [
          'En 2002, la USGA y The R&A publicaron “A Modification of the Rules of Golf for Golfers with Disabilities”. Por primera vez las excepciones se ordenaron por tipo de discapacidad. Ese texto es el antecedente directo de la Regla 25.',
          'El mismo año se aplicaba ya el fallo de la Suprema Corte de Estados Unidos en PGA Tour v. Martin (2001): un ajuste razonable, como usar carrito, no es una ventaja ilegítima.',
          'Desde enero de 2023 la Regla 25 vive dentro de las Reglas de Golf y vale en stroke play y match play. Modifica unos veinte puntos del reglamento general.',
        ],
      },
      {
        heading: 'Cuatro caminos, no un permiso abierto',
        paragraphs: [
          'La 25.2 cubre la discapacidad visual: un guía con estatus de caddie y, en el bunker, la posibilidad de tocar la arena en la preparación del golpe. La 25.3 autoriza prótesis y, cuando hace falta, anclar el palo al cuerpo.',
          'La 25.4 abre greens y bunkers a sillas y monoplazas, y adapta la altura del dropeo. La 25.5 permite, en discapacidad intelectual validada por Virtus, un ayudante además del caddie.',
        ],
      },
    ],
  },
  {
    slug: 'ranking-wr4gd',
    title: 'Cómo se entra al ranking mundial',
    excerpt: 'No todas las discapacidades puntúan igual. EDGA distingue tres pases, y el WR4GD separa Gross, Neto y Stableford.',
    category: 'Ranking',
    date: '2026-03-12',
    readTime: '5 min',
    sections: [
      {
        heading: 'Quién clasifica',
        paragraphs: [
          'La EDGA, fundada en 2000, audita la elegibilidad. El examen médico usa diez categorías del Comité Paralímpico Internacional: deficiencia articular, fuerza muscular, longitud de extremidades, amputación, afecciones neurológicas, baja estatura, discapacidad visual e intelectual.',
          'El WR4GD Pass cumple el umbral mínimo y abre el circuito mundial, el G4D Tour y el U.S. Adaptive Open, con puntos. El ACCESS Pass compite en eventos de desarrollo, sin ranking. El Access Conditional vale solo en el país que lo reconoce.',
        ],
      },
      {
        heading: 'Tres divisiones',
        paragraphs: [
          'El ranking, administrado por EDGA, The R&A y la USGA, mira 104 semanas. Gross es para un Hándicap Index de 18.4 o menor. Neto ajusta ese mismo rango por hándicap. Stableford cubre de 18.5 a 54.0.',
          'Héctor Antonio Ramírez Taxilaga, de Minatitlán, es el mexicano mejor calificado en Neto. Alan Salas, de la Ciudad de México, ocupa el lugar 25 en Stableford.',
        ],
      },
    ],
  },
  {
    slug: 'equipo-que-abre-el-campo',
    title: 'El equipo que hace posible el golpe',
    excerpt: 'Paragolfer, SoloRider, prótesis y grips no son accesorios. Son la diferencia entre quedarse fuera del hoyo y jugarlo.',
    category: 'Equipo',
    date: '2026-03-18',
    readTime: '5 min',
    sections: [
      {
        heading: 'Ponerse de pie para rotar',
        paragraphs: [
          'El Paragolfer, de Ottobock, eleva con un arnés y un motor hidráulico a la persona hasta una postura erguida. Así puede rotar el torso. Para quien vive con una lesión medular, esa verticalización también cuida el hueso, la circulación y la digestión.',
        ],
      },
      {
        heading: 'Cruzar el green sin marcarlo',
        paragraphs: [
          'El SoloRider reparte el peso con neumáticos de muy baja presión, por debajo de una pisada. Por eso los comités pueden autorizar su paso por el green. El asiento gira e inclina para el address.',
          'Las prótesis de swing, en fibra de carbono, absorben el torque. Los grips de mayor diámetro y los guantes con cincha compensan la falta de fuerza en la mano. La Regla 25.4 obliga a los comités a garantizar el acceso de estos vehículos.',
        ],
      },
    ],
  },
  {
    slug: 'mexico-2012-2026',
    title: 'México, de un hermano al Adaptive Open',
    excerpt: 'En 2012 Alejandro Florero buscó cómo seguir jugando. En 2026 el Club de Golf México recibió a 25 jugadores de cuatro países.',
    category: 'México',
    date: '2026-03-20',
    readTime: '5 min',
    sections: [
      {
        heading: '2012',
        paragraphs: [
          'Alejandro Florero y su hermano, diagnosticado con Parkinson, inician el golf adaptado en México. La asociación atiende hoy en Xochimilco y acompaña jugadores en ocho estados.',
        ],
      },
      {
        heading: '2024, 2025 y 2026',
        paragraphs: [
          'En 2024 se juega el primer Torneo Nacional en el Club de Golf México, con 13 jugadores. En 2025, Alfonso Balderas y Guadalupe Govea debutan en los Deaflympics de Tokio.',
          'En 2026, el I Campeonato Nacional FMG Adaptive Open vuelve al Club de Golf México. El formato es Stableford a 18 hoyos diarios. Participan 25 jugadores con discapacidad motriz, intelectual y sensorial, incluidos dos de Guatemala, uno de Argentina y uno de Colombia.',
        ],
      },
    ],
  },
  {
    slug: 'mexicanos-en-el-circuito',
    title: 'Quienes ya compiten con el nombre de México',
    excerpt: 'Un campeón mundial B1, un perfil en la EDGA, un lugar 25 de Stableford y la primera delegación sorda en unos Deaflympics.',
    category: 'Jugadores',
    date: '2026-04-02',
    readTime: '6 min',
    sections: [
      {
        heading: 'Ricardo Silva de Luna',
        paragraphs: [
          'En la categoría B1, ceguera total, Silva de Luna compite con su guía Ismael Álvarez Delgado. Se coronó campeón mundial B1 Men’s Low Net en el ISPS Handa Canadian Open, campeonato del mundo de la IBGA en Simcoe, Ontario, frente a 20 golfistas y sus guías.',
          'En el Spanish Blind Golf Open 2026, en Isla Canela, fue primero en B1 varonil con 229 golpes. En el circuito del oeste de Canadá ya había sido subcampeón Gross B1.',
        ],
      },
      {
        heading: 'Ranking, juego sentado y Deaflympics',
        paragraphs: [
          'Héctor Antonio Ramírez Taxilaga, de Minatitlán, lidera entre los mexicanos la división Neto del WR4GD. Alan Enrique Salas Rueda, de la Ciudad de México, va en el lugar 25 de Stableford, con 15,833 puntos y hándicap 24.3. Mauricio Gutiérrez empezó a jugar a los cuatro años y hoy destaca sentado; la EDGA publica su perfil.',
          'En Tokio 2025, Alfonso Balderas (Querétaro) y Guadalupe Govea (Guadalajara) fueron la primera participación de México en el golf de los Deaflympics.',
        ],
      },
    ],
  },
]

export const getPost = (slug) => posts.find((post) => post.slug === slug)
